import { useQuery } from '@ts-core/lib/apollo';

import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import { getAssignmentsQuery, GetAssignmentsQueryResult, GetAssignmentsQueryVariables } from '../graphql/queries/getAssignmentsQuery';
import { Assignment } from '../types';

interface AssignmentsHookInput {
  courseId: string;
}

interface AssignmentsHookOutput {
  assignments?: Assignment[];
  loading: boolean;
}

export default function useAssignments(input: AssignmentsHookInput): AssignmentsHookOutput {
  const { courseId } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading } = useQuery<GetAssignmentsQueryResult, GetAssignmentsQueryVariables>(getAssignmentsQuery, {
    variables: { courseId },
    fetchPolicy: 'cache-and-network',
    onError: showErrorNotification,
  });

  return {
    assignments: data?.assignments,
    loading,
  };
}
